const actionTypes = require('constants/contactCenter/actionTypes');
const { ERROR_INVALID_PASSWORD, ERROR_USER_BLOCKED } = require('constants/contactCenter/errorTypes');
const { FIRST_STEP } = require('constants/index');
const { AGENT_INFO, TOKEN_CREDENTIAL } = require('constants/session');

//@core
const { formatText } = require('core/i18n').i18n;

//@utilities
const { APIPost } = require('utilities/APIRequestHelper');
const Storage = require('utilities/storage');
const authenticationHelper = require('utilities/contactCenter/authenticationHelper');
const usd = require('utilities/usd');

// @contactCener
// @constans
import { DR_SESSION } from 'constants/contactCenter/session';

const PASSWORD_ERRORS = {
    [ERROR_INVALID_PASSWORD]: { errorType: ERROR_INVALID_PASSWORD, errorMessage: formatText('stepClientLogin-errorInvalidPassword') },
    [ERROR_USER_BLOCKED]: { errorType: ERROR_USER_BLOCKED, errorMessage: formatText('stepClientLogin-errorUserBlocked') }
};

const traceAction = (type, payload) => ({
    type,
    payload
});

const bindClientInteraction = (interactionId, inOffice, dispatch, getState) => {
    const clientData =  getState().customerFinder.getIn([ 'steps', FIRST_STEP, 'response' ]);
    const agentInfo = JSON.parse(Storage.cookies.get(AGENT_INFO));
    const bankToken = agentInfo.bankToken;
    const codigoPersona =  clientData.getIn([ 'documento', 'personaInter', 'codigodepersona' ]);
    const tipoPersona =  clientData.getIn([ 'documento', 'personaInter', 'tipodepersona' ]);

    const params = {
        header: {
            isOfficeAgent: inOffice ? 'office' : 'CC'
        },
        query: {
            bankToken,
            codigoPersona,
            interactionId,
            tipoPersona
        }
    };

    dispatch(traceAction(actionTypes.CUSTOMER_FINDER_TRACE_BIND_CLIENT_INTERACTION_REQUEST_START, { params }));

    return APIPost({ dispatch, endpoint: 'bindClientInteraction', params })
        .then(response => {
            dispatch(traceAction(actionTypes.CUSTOMER_FINDER_TRACE_BIND_CLIENT_INTERACTION_REQUEST_SUCCESSFUL, { response }));
            return response;
        })
        .catch(error => {
            dispatch(traceAction(actionTypes.CUSTOMER_FINDER_TRACE_BIND_CLIENT_INTERACTION_REQUEST_ERROR, { error }));
            throw error;
        });
};

const generateRepresentationToken = (interactionId, dispatch, getState) => {
    const clientData =  getState().customerFinder.getIn([ 'steps', FIRST_STEP, 'response' ]);
    const agentInfo = JSON.parse(Storage.cookies.get(AGENT_INFO));
    const agentId = agentInfo.agentId;
    const bankToken = agentInfo.bankToken;
    const codigoPersona =  clientData.getIn([ 'documento', 'personaInter', 'codigodepersona' ]) || Storage.cookies.get(TOKEN_CREDENTIAL);
    const tipoPersona =  clientData.getIn([ 'documento', 'personaInter', 'tipodepersona' ]);

    const params = {
        query: {
            agentId,
            bankToken,
            codigoPersona,
            force: true,
            interactionId,
            tipoPersona
        }
    };

    dispatch(traceAction(actionTypes.CUSTOMER_FINDER_TRACE_GENERATE_REPRESENTATION_TOKEN_REQUEST_START, { params }));

    return APIPost({ dispatch, endpoint: 'representationToken', params })
        .then(response => {
            dispatch(traceAction(actionTypes.CUSTOMER_FINDER_TRACE_GENERATE_REPRESENTATION_TOKEN_REQUEST_SUCCESSFUL, { response }));
            return response;
        })
        .catch(error => {
            dispatch(traceAction(actionTypes.CUSTOMER_FINDER_TRACE_GENERATE_REPRESENTATION_TOKEN_REQUEST_ERROR, { error }));
            throw error;
        });
};

const raiseInteractionSecurityLevelN1ByPositions = (interactionId, positions, values, tokenCredential, dispatch) => {
    const params = {
        header: {
            openbankAuthToken: tokenCredential,
            openBankInteractionId: interactionId
        },
        query: {
            posValues: values.join(' '),
            positions: positions.join(' ')
        }
    };

    dispatch(traceAction(actionTypes.CUSTOMER_FINDER_TRACE_RAISE_TO_N1_REQUEST_START, Object.assign({}, params, { query: { posValues: '***', positions: '***' } })));

    return APIPost({ dispatch, endpoint: 'raiseToN1ByPosition', params })
        .then(response => {
            dispatch(traceAction(actionTypes.CUSTOMER_FINDER_TRACE_RAISE_TO_N1_REQUEST_SUCCESSFUL, { response }));
            return response;
        })
        .catch(error => {
            dispatch(traceAction(actionTypes.CUSTOMER_FINDER_TRACE_RAISE_TO_N1_REQUEST_ERROR, { error }));
            throw error;
        });
};

const securityLevelSetPromise = (level, dispatch) => {
    const resolveValue = { level };

    dispatch(traceAction(actionTypes.CUSTOMER_FINDER_TRACE_SECURITY_LEVEL_SET, resolveValue));
    return Promise.resolve(resolveValue);
};

const initSecurityInformation = (interactionId, securityLevel, getState) => {
    const clientData =  getState().customerFinder.getIn([ 'steps', FIRST_STEP, 'response' ]);
    const agentInfo = JSON.parse(Storage.cookies.get(AGENT_INFO));
    const agentId = agentInfo.agentId;
    const agentToken = agentInfo.bankToken;
    const codigoPersona =  clientData.getIn([ 'documento', 'personaInter', 'codigodepersona' ]);
    const tipoPersona =  clientData.getIn([ 'documento', 'personaInter', 'tipodepersona' ]);
    const clientId = authenticationHelper.formatClientId(tipoPersona, codigoPersona);
    const sessionId = authenticationHelper.generateUniqueIdentifierSession();

    sessionStorage.setItem(DR_SESSION, JSON.stringify({ agentId, agentToken, clientId, interactionId, securityLevel, sessionId }));
    usd.initDisasterRecovery(agentId, agentToken, clientId, interactionId, securityLevel, sessionId);
}

const tokenCredentialSuccess = (token) => ({
    type: actionTypes.CUSTOMER_FINDER_AUTHENTICATION_TOKEN_CREDENTIAL,
    payload: {
        token
    }
});

const raiseToN1ByPositions = (interactionId, tokenCredential, positions, values, dispatch, getState) => {
    let representationTokenPromise;
    let shouldStoreTokenCredential = false;

    if (tokenCredential) {
        representationTokenPromise = Promise.resolve({ tokenCredential });
    } else {
        representationTokenPromise = generateRepresentationToken(interactionId, dispatch, getState);
        shouldStoreTokenCredential = true;
    }

    return representationTokenPromise.then(generateRepresentationTokenResponse => {
        const representationToken = generateRepresentationTokenResponse.tokenCredential;

        if (shouldStoreTokenCredential) {
            dispatch(tokenCredentialSuccess(representationToken));
        }

        return raiseInteractionSecurityLevelN1ByPositions(interactionId, positions, values, representationToken, dispatch)
            .catch(errorResponse => {
                switch (errorResponse.body.error) {
                    case ERROR_INVALID_PASSWORD:
                        throw PASSWORD_ERRORS[ERROR_INVALID_PASSWORD];

                    case ERROR_USER_BLOCKED:
                        throw PASSWORD_ERRORS[ERROR_USER_BLOCKED];

                    default:
                        throw errorResponse;
                }
            });
    });
};

module.exports = {
    PASSWORD_ERRORS,
    bindClientInteraction,
    raiseToN1ByPositions,
    securityLevelSetPromise,
    initSecurityInformation,
};
